/**
 * 关于我们 — 静态页,markdown 渲染
 */
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

const body = `
西安铂傲智能科技有限公司是一家以信息技术为核心驱动力的高科技企业,总部位于陕西省西安市,聚焦 **AI 智能体产品研发、企业数字化解决方案、出海服务支持**。公司自 2021 年成立以来,始终深耕企业数字化解决方案,致力于将复杂的 AI 技术转化为简单易用的"新质生产力"。

---

## 为什么做这个应用

公司创始团队及员工的**亲戚朋友**中,有多个孩子参加 2026 年陕西高考。看到他们面对堆积如山的招生资料、专业组规则、分数线变化无从下手,加上市面上公开免费的工具要么太旧(老高考数据)、要么太花(广告多 / 注册门槛高)、要么太深(只给"专业术语"不给"为什么"),我们决定把公司积累的 AI 能力、数据整合能力和工程交付能力,用在一个真正帮到考生的小工具上。

**高考志愿填报助手**(本网站)是这个方向上的第一个公开产品。

---

## 怎么使用

公开的部分(查院校、看统计、实时热度)直接打开就能用。

AI 智能志愿这一块,目前只对熟悉的家庭开放——主要是公司同事、亲戚朋友,以及他们介绍来的考生。如果你不确定在不在范围内,直接在 AI 智能志愿页填表后点"试用",我们看到后会在 1-2 天内联系你确认。

**账号是手机号 + 密码**,登录后每天可以免费生成 5 次方案,够用。我们不会用你的手机号做任何商业用途。

**怎么联系**:AI 智能志愿页有微信二维码,或者发邮件到 support@boaoai.cn。

> 不发短信验证码,也不搞花哨的弹窗——你愿意来就已经给我们面子,我们不好意思再多打扰一步。

---

## 数据来源与准确度

应用本身的数据大约有**十几万条**,覆盖 2021-2025 陕西录取明细、院校字典、专业组规则等。数据通过**网络多渠道抓取和印证**:
- 公开的院校招生章程与历年录取数据
- 各类教育考试院发布的政策文件
- 第三方教育数据平台
- 人工抽样核对

经多源交叉验证后,**数据准确度为 99.87%**。剩余 0.13% 的偏差主要来自:院校名称变体、专业组合并规则差异、分数小数处理等细微处。这些偏差通常不影响志愿填报的主判断,但仍请以**陕西招生考试院官方数据**和**各院校招生章程**为准。

---

## 免责声明

本网站所提供的所有信息仅供参考,不构成任何录取承诺。**高考志愿是个人决策**,实际填报前请以 **陕西招生考试院官方数据** 和 **各院校招生章程** 为准。

AI 智能志愿模块输出的"冲/稳/保"分档基于历史数据与规则推演,不构成"稳上""必中""包录"等承诺。
`

export default function About() {
  return (
    <div>
      <h2 className="serif" style={{ fontSize: 'var(--fs-h1)', fontWeight: 600, lineHeight: 1.15, margin: '0 0 .5rem' }}>
        关于我们
      </h2>
      <p style={{ color: 'var(--ink2)', fontSize: 'var(--fs-body)', marginBottom: '1.5rem' }}>
        高考志愿填报助手的开发团队与原则。
      </p>

      <div className="card" style={{ padding: '1.25rem' }}>
        <div className="md-report" style={{ fontSize: 'var(--fs-body)' }}>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{body}</ReactMarkdown>
        </div>
      </div>
    </div>
  )
}

